<template>
  <div>
    <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
      <div class="uk-card-body">
        <div class="uk-overflow-auto">
          <table class="uk-table uk-table-divider" v-if="sales.length">
            <thead>
              <tr>
                <th class="uk-width-small">Datum</th>
                <th class="uk-width-small">Bestell-Nr.</th>
                <th>Fahrzeug</th>
                <th>Preis Netto</th>
                <th class="uk-width-small">Bestellung (PDF)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="sale in sales">
                <tr v-for="(item, key) in sale.items" :key="item.id">
                  <td v-if="key == 0">
                    {{ sale.date }} <br />
                    <span class="uk-text-small uk-text-muted">{{ sale.time }} Uhr</span>
                  </td>
                  <td v-else>&nbsp;</td>
                  <td v-if="key == 0">{{ sale.number }}</td>
                  <td v-else>&nbsp;</td>
                  <td>
                    {{ item.make }} {{ item.model }} {{ item.edition }}<br />
                    <span class="uk-text-small"> Nr.: {{ item.carId }} </span>
                  </td>
                  <td>{{ item.price }}</td>
                  <td class="uk-text-right">
                    <a
                      href="#"
                      class="uk-text-primary"
                      :uk-icon="'icon: download'"
                      @click.prevent="downloadPdf(sale)"
                    ></a>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div v-if="!sales.length" class="uk-margin-remove uk-h4">
          Keine Bestellungen vorhanden!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
export default {
  props: {
    sales: {
      required: true
    }
  },
  data() {
    return {
      requestDownload: null
    }
  },
  methods: {
    downloadPdf(sale) {
      axios({
        url: `${baseURL}/sale/print/${sale.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Bestellschein-${sale.number}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
